import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { FORM_PATH_TOKEN, IFormElementManifest, IFormElementManifestService } from '@farris/devkit';
import { share } from 'rxjs/operators';
import { BasePathService } from '@farris/rtf';

@Injectable()
export class FormElementManifestService implements IFormElementManifestService {
  private static mainfests = new Map<string, Observable<IFormElementManifest>>();
  constructor(
    private injector: Injector,
    @Inject(FORM_PATH_TOKEN) private modulePath,
    private httpClient: HttpClient
  ) { }
  public load(): Observable<any> {
    if (this.modulePath.endsWith('\/')) {
      this.modulePath = this.modulePath.substring(0, this.modulePath.length - 1);
    }
    const formManifestPath = BasePathService.convertPath(`${this.modulePath}/viewrules/form.manifest.json?version=${new Date().valueOf().toString()}`);
    const request$ = FormElementManifestService.mainfests.get(this.modulePath);
    if (request$) {
      return request$;
    } else {
      const req$ = this.httpClient.get<IFormElementManifest>(formManifestPath, { responseType: 'json' }).pipe(share());
      FormElementManifestService.mainfests.set(this.modulePath, req$);
      return req$;
    }
  }
}
